import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell, { storedSession } from '../components/AppShell';
import CandidateDatabase from '../components/candidates/CandidateDatabase';
import { canUseCandidates } from '../components/candidates/common';
import { ToastProvider } from '../components/ui/Kit';

// /candidates — the candidate database for company admins and people with Recruit (bundle 4a-2).
export default function CandidatesPage() {
  const navigate = useNavigate();
  const { user } = storedSession();
  const allowed = canUseCandidates(user);
  useEffect(() => {
    if (!localStorage.getItem('token')) navigate('/');
    else if (!allowed) navigate('/jobs');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!allowed) return null;
  return (
    <ToastProvider>
      <AppShell active="candidates">
        <h1 className="text-2xl font-extrabold text-[#0F172A]">Candidates</h1>
        <p className="text-sm text-[#64748B] mt-1 mb-5">Everyone you’ve sourced, imported or received — one record per person.</p>
        <CandidateDatabase />
      </AppShell>
    </ToastProvider>
  );
}
